export default "__VITE_ASSET__Daje_QAn__"